module.exports = __webpack_public_path__ + "img/hauptseite-unsere-prinzipien.03b973a4.jpg";